import { Form } from 'antd';
import { FC, memo, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppMessage } from '@/common/components';
import { AppRoutes, FormFieldsErrors } from '@/common/interfaces';
import { extractFormErrors, messageOnError } from '@/common/utils';

import { Site, SiteFormFields, SiteFormInputs, useCreateSitesMutation } from '@/modules/Sites';

import { SitesFormView } from './SitesFormView';
import { sitesFormValidationSchema } from './validation';

export const SitesCreateFormContainer: FC = memo(() => {
  const navigate = useNavigate();
  const appMessageApi = AppMessage.useControls();
  const [form] = Form.useForm<SiteFormFields>();
  const [formErrors, setFormErrors] = useState<FormFieldsErrors<typeof SiteFormInputs>>(null);

  const { mutate: createSiteMutation, isLoading: createSiteIsLoading } = useCreateSitesMutation()({
    onSuccess: (data: Site) => {
      appMessageApi.success('Сайт створено успішно!');

      navigate(AppRoutes.SitesById.replace(':siteId', data.id));
    },
    onError: (err) => {
      setFormErrors(extractFormErrors<typeof SiteFormInputs>(err));
      messageOnError(err, appMessageApi);
    }
  });

  const initialValues: SiteFormFields = {
    name: undefined
  };

  const handleFinish = useCallback((values: SiteFormFields): void => {
    setFormErrors(null);

    createSiteMutation(values);
  }, []);

  const handleBack = useCallback((): void => {
    setFormErrors(null);

    navigate(AppRoutes.Sites);
  }, []);

  const handleFinishFailed = useCallback((): void => {
    setFormErrors(null);
  }, []);

  return (
    <SitesFormView
      form={ form }
      formName="site-create"
      formType="create"
      formErrors={ formErrors }
      initialValues={ initialValues }
      isFormLoading={ createSiteIsLoading }
      validationSchema={ sitesFormValidationSchema }
      handleFinish={ handleFinish }
      handleBack={ handleBack }
      handleFinishFailed={ handleFinishFailed }
    />
  );
});
